import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const useRemoveFileQuery = () => {
  const { mutateAsync, isLoading, isSuccess } = useMutation((id: string) =>
    api.delete(API_URL.DOCUMENTS_FILES_BY_FILE_ID(id))
  );

  const { mutateAsync: removeFiles } = useMutation(
    (fileIds: string[]) => Promise.all(fileIds.map((id) => api.delete(API_URL.DOCUMENTS_FILES_BY_FILE_ID(id))))
  );

  return {
    removeFile: mutateAsync,
    removeFiles,
    isLoading,
    isSuccess,
  };
};

export default useRemoveFileQuery;
